import { Backdrop, CircularProgress } from "@mui/material";
import React, { useContext } from "react";
import { SpinnerContext } from "../../SpinnerContext";

export const SpinnerBackdrop = () => {
  const { isSpinnerShow } = useContext(SpinnerContext);
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme: any) => theme.zIndex.drawer + 1 }}
      open={isSpinnerShow}
    >
      <CircularProgress />
    </Backdrop>
  );
};
